module.exports = __webpack_public_path__ + "static/img/level-3-2.de63fbf5.png";